import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "banner_news",
  style: {
    backgroundImage: 'url(http://www.boyuyinuo.com/webcss/banner_news.jpg)'
  }
};
const _hoisted_3 = {
  class: "banner_news_title acea-row row-center-wrapper"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "banner_news_miaoshu acea-row row-center-wrapper"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "news_postion"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "lznelist_all acea-row row-top"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "lznelist_item_pic"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "lznelist_item_kuang acea-row row-top"
};
const _hoisted_17 = {
  class: "lznelist_item_title acea-row row-top"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "lznelist_item_miaoshu acea-row row-top"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  class: "lznelist_item_btn acea-row row-right"
};
const _hoisted_24 = {
  class: "lznelist_item_seemore"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu,
    xzlag: $data.xzlag
  }, null, 8, ["xzmenu", "xzlag"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "NEWS CENTER")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "新闻动态")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "The latest official updates or news provide you with first-hand information about us")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 官方发布的最新动态或消息，为您提供关于我们的第一手资讯")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "POSTION： HOME > NEWS LIST")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "当前位置： 主页 > 资讯列表")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.catenews_list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "lznelist_item acea-row row-top",
      onClick: $event => $options.goxinwen(item.id, 4)
    }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
      src: item.image_input
    }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.share_title), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.share_synopsis), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.synopsis), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Details")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "查看详情")) : _createCommentVNode("", true)])])])], 8, _hoisted_13);
  }), 256))]), _createVNode(_component_zrcfooter, {
    xzlag: $data.xzlag
  }, null, 8, ["xzlag"])]);
}